import AxiosAuthInstance from './AxiosInstance';

const API_BASE_URL = '/application-messages';

export const createMessage = (data) => {
    return AxiosAuthInstance.post(API_BASE_URL, data);
};

export const getAllMessages = (params) => {
    return AxiosAuthInstance.get(API_BASE_URL, { params });
};

export const getMessageById = (id) => {
    return AxiosAuthInstance.get(`${API_BASE_URL}/${id}`);
};

export const updateMessage = (id, data) => {
    return AxiosAuthInstance.put(`${API_BASE_URL}/${id}`, data);
};

export const deleteMessage = (id) => {
    return AxiosAuthInstance.delete(`${API_BASE_URL}/${id}`);
};

export const showMessage = (id) => {
    return AxiosAuthInstance.patch(`${API_BASE_URL}/${id}/show`);
};

export const hideMessage = (id) => {
    return AxiosAuthInstance.patch(`${API_BASE_URL}/${id}/hide`);
};

export const getActiveMessagesByType = (messageType) => {
    return AxiosAuthInstance.get(`${API_BASE_URL}/type/${messageType}`);
};

export const getAllActiveMessages = () => {
    return AxiosAuthInstance.get(`${API_BASE_URL}/active/all`);
};
